export default {
  Code: "",
  Desc: "",
  UseInAp: true,
  UseInAr: true,
  UserModified: localStorage.getItem("UserName"),
};
